<div class="row" id="scheduleRow">
  <div class="col-md-12" id="scheduleDiv">
    <mat-card appearance="outlined" class="marB16" id="scheduleMatCard">
      <div *ngIf="editactivity">
        <button mat-icon-button class="close-button" [mat-dialog-close]="true" id="scheduleBtn">
          <mat-icon class="close-icon" color="warn" id="scheduleMatIcon">close</mat-icon>
        </button>
      </div>
      <div class="d-flex justify-content-between" style="margin-left: 18px; margin-top: 18px">
        <div class="txt_left">
          <h4 class="h3Header GreyDarkest text-1line marB16" id="scheduleAcName">
            {{ checkInterviewSchDataObj.activityName }}
          </h4>
        </div>
        <div class="d-flex" style="margin-right: 18px">
          <span class="data-letters float-left marR6 listleft" c>{{ loginUserName || 'NA' | initials }}</span>
          <h5 class="marginicon40 h5Header GreyLight marT8 float-right marR16" id="scheuleLogin">
            {{ loginUserName }}
          </h5>
          <span class="float-right marT4" id="scheduleDate">
            <span class="marginicon40 mainBodyTxt3 GreyLight blockInfo" *ngIf="timeModifiedOn; else elseTemplate">
              {{ timeModifiedOn | dateTransform }}
            </span>
            <ng-template class="mainBodyTxt3 GreyLight blockInfo" #elseTemplate id="scheduleTemp"> </ng-template>
          </span>
        </div>
      </div>

      <mat-card-content
        class="clearfix"
        *ngIf="isCollapsed"
        id="scheduleForm"
        [ngClass]="{ readActivityDisable: data && data.readFlag }"
      >
        <form name="schedueleIntForm" #f="ngForm">
          <div *ngIf="this.testformValid(!f.invalid)"></div>

          <mat-form-field class="custom-form-field" *ngIf="!hideFieldsForRecruiter">
            <mat-label>Template</mat-label>
            <mat-select
              (selectionChange)="getTemplateData($event)"
              name="selectedTemplate"
              [(value)]="inputVal"
              [required]="tempReq"
              [(ngModel)]="selectedTemplate"
            >
              <mat-option *ngFor="let template of templateData" [value]="template.clauseid" class="custom-select-option"
                >{{ template.templateName }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="row">
            <div class="col-md-2">
              <mat-form-field>
                <input
                  matInput
                  required
                  [matDatepicker]="picker"
                  name="startDate"
                  [(ngModel)]="startDate"
                  placeholder="Appointment"
                  (dateChange)="addEvent1($event)"
                />
                <mat-icon matSuffix>
                  <img
                    src="assets/images/icons/purple_icons/icon-calendar.png"
                    alt="icon-calendar"
                    (click)="picker.open()"
                  />
                </mat-icon>
                <mat-datepicker #picker touchUi></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-md-2 offset-md-1" *ngIf="!hideFieldsForRecruiter">
              <mat-form-field>
                <input
                  matInput
                  placeholder="Time"
                  required
                  name="startTime"
                  [(ngModel)]="startTime"
                  aria-label="startTime"
                  [ngxTimepicker]="timepicker"
                  [format]="24"
                  (ngModelChange)="select(startTime)"
                  readonly
                />
                <ngx-material-timepicker #timepicker></ngx-material-timepicker>
              </mat-form-field>
            </div>
          </div>

          <div *ngIf="!venueHide && !hideFieldsForRecruiter">
            <mat-form-field class="custom-form-field">
              <mat-label>Venue</mat-label>
              <mat-select [required]="companyHiringType != 2" name="venue" [(ngModel)]="selectedVenue">
                <mat-option *ngFor="let place of venue" [value]="place" class="custom-select-option">
                  {{ place.venueName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <mat-checkbox
            class="custom-checkbox"
            aria-label="checkbox"
            disableRipple="true"
            name="MailCheck"
            [(ngModel)]="sendMailCheck"
            (change)="sendMailEnable()"
            *ngIf="!hideFieldsForRecruiter"
            >Send email communication to candidate</mat-checkbox
          >

          <mat-form-field class="custom-form-field" *ngIf="!isNotesInExpectedFormat">
            <input
              matInput
              placeholder="Remarks"
              name="notes"
              [(ngModel)]="notes"
              (input)="inputValRemarks = $event.target.value"
            />
          </mat-form-field>

          <div
            *ngIf="companyHiringType === '2' && checkInterviewSchDataObj.activityId === 400104 && testScoreData"
            class="test-score-container marB16"
          >
            <h5 class="h5Header GreyDarkest marB16">{{ testScoreData.heading }}</h5>
            <table class="test-score-table" style="width: 100%; border-collapse: collapse">
              <tbody>
                <tr *ngFor="let score of testScoreData.scores" style="border-bottom: 1px solid #e0e0e0">
                  <td style="padding: 12px 8px; font-weight: 500; color: #424242; width: 60%">
                    {{ score.test }}
                  </td>
                  <td style="padding: 12px 8px; color: #616161; word-break: break-word">
                    {{ score.marks }}
                  </td>
                </tr>
                <tr
                  *ngIf="testScoreData.totalMarks"
                  style="background-color: #f5f5f5; font-weight: 600; border-bottom: 1px solid #e0e0e0"
                >
                  <td style="padding: 12px 8px; color: #424242">TOTAL OBTAINED MARKS</td>
                  <td style="padding: 12px 8px; color: #424242">
                    {{ testScoreData.totalMarks }}
                  </td>
                </tr>
                <tr *ngIf="testScoreData.englishPassage" style="border-bottom: 1px solid #e0e0e0">
                  <td style="padding: 12px 8px; font-weight: 500; color: #424242">ENGLISH WRITTEN TEST PASSAGE</td>
                  <td style="padding: 12px 8px; color: #616161; word-break: break-word; white-space: pre-wrap">
                    {{ testScoreData.englishPassage }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div [style.display]="sendMailCheck ? 'block' : 'none'">
            <div class="row" id="schedulerow1">
              <div class="col-md-12">
                <mat-card appearance="outlined" class="marB16" id="mCradSchedule">
                  <mat-card-actions *ngIf="editactivity">
                    <button mat-icon-button class="close-button" [mat-dialog-close]="true" id="scheduleClose">
                      <mat-icon class="close-icon" color="warn">close</mat-icon>
                    </button>
                  </mat-card-actions>
                  <div class="d-flex justify-content-between" style="margin-left: 18px; margin-top: 18px">
                    <div class="txt_left">
                      <h4 class="h3Header GreyDarkest text-1line marB16" id="candCommunic">
                        Communicate with candidate
                      </h4>
                    </div>
                    <div class="d-flex">
                      <span class="float-right marT4">
                        <span
                          class="marginicon40 mainBodyTxt3 GreyLight blockInfo"
                          *ngIf="timeModifiedOn; else elseTemplate"
                          id="scheduleDateTrans"
                        >
                          {{ timeModifiedOn | dateTransform }}
                        </span>
                        <ng-template class="mainBodyTxt3 GreyLight blockInfo" #elseTemplate id="elseTemp">
                        </ng-template>
                      </span>
                      <span class="data-letters float-left marR6 listleft" id="initialSchedule">{{
                        loginUserName || 'NA' | initials
                      }}</span>

                      <h5 class="marginicon40 h5Header GreyLight marT8 float-right marR16" id="loginSchedule">
                        {{ loginUserName }}
                      </h5>
                    </div>
                  </div>
                  <mat-card-content *ngIf="isCollapsed">
                    <form name="correpForm1" #f="ngForm">
                      <div *ngIf="this.testformValid(!f.invalid)" id="testForm"></div>
                      <mat-form-field style="width: 15%">
                        <mat-label id="temp">Template</mat-label>
                        <mat-select
                          (selectionChange)="getTemplateData($event)"
                          required
                          name="template"
                          [(ngModel)]="selectedTemplate"
                          [disabled]="templateDisable"
                        >
                          <mat-option
                            *ngFor="let status of templateData"
                            [value]="status.clauseid"
                            class="custom-select-option"
                          >
                            {{ status.templateName }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <div class="row">
                        <div class="col-md-10">
                          <mat-form-field class="custom-form-field" id="toInp">
                            <input
                              #toValue
                              matInput
                              placeholder="To"
                              required
                              name="toInput"
                              [value]=""
                              [disabled]="toDisable"
                              (input)="toInputValue = $event.target.value"
                              [(ngModel)]="toInputValue"
                              id="inputTo"
                            />
                          </mat-form-field>
                        </div>
                        <button
                          mat-icon-button
                          class="text-btn"
                          name="ccbtn"
                          (click)="ccEnableDisable()"
                          id="btns1"
                          style="font-size: 16px"
                        >
                          CC
                        </button>
                        <button
                          mat-icon-button
                          class="text-btn"
                          name="bccbtn"
                          (click)="bccEnableDisable()"
                          id="btns2"
                          style="font-size: 16px"
                        >
                          BCC
                        </button>
                      </div>

                      <mat-form-field
                        class="custom-form-field"
                        [ngStyle]="{ visibility: ccEnable ? 'visible' : 'hidden' }"
                      >
                        <input
                          #ccValue
                          matInput
                          placeholder="CC"
                          name="ccinput"
                          [value]=""
                          id="CCValue"
                          (input)="ccInputValue = $event.target.value"
                        />
                      </mat-form-field>

                      <mat-form-field
                        class="custom-form-field"
                        [ngStyle]="{ visibility: bccEnable ? 'visible' : 'hidden' }"
                      >
                        <input
                          #bccValue
                          matInput
                          placeholder="BCC"
                          name="bccinput"
                          [value]=""
                          id="BCCValue"
                          (input)="bccInputValue = $event.target.value"
                        />
                      </mat-form-field>

                      <mat-form-field class="custom-form-field">
                        <input
                          #subjectValue
                          matInput
                          placeholder="Subject"
                          required
                          name="subjectinput"
                          [value]=""
                          id="subjectValue"
                          (input)="subjectInputValue = $event.target.value"
                          [(ngModel)]="subjectInputValue"
                        />
                      </mat-form-field>

                      <mat-form-field class="custom-form-field">
                        <textarea
                          #bodyValue
                          matInput
                          rows="10"
                          placeholder="Body"
                          required
                          name="bodyinput"
                          (input)="bodyInputValue = $event.target.value"
                          id="bodyValue"
                          [(ngModel)]="bodyInputValue"
                        ></textarea>
                      </mat-form-field>

                      <mat-form-field class="custom-form-field">
                        <input
                          matInput
                          [(ngModel)]="remarksInputValue"
                          name="remarksinput"
                          #remarksValue
                          placeholder="Remarks"
                          value=""
                          id="remarksinputs"
                          (input)="remarksInputValue = $event.target.value"
                        />
                      </mat-form-field>

                      <div class="row" *ngIf="!ifCoupled">
                        <div class="col-md-4" *ngIf="!interviewFlag">
                          <div class="row nomarLR padTB16">
                            <div class="col-6 padR8">
                              <button
                                mat-raised-button
                                class="primary-btn btnfullWdth"
                                [disabled]="f.invalid"
                                type="submit"
                                name="sendbtn"
                                (click)="send()"
                              >
                                Send
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </mat-card-content>
                  <mat-card-actions class="collapseAction m-auto">
                    <div>
                      <mat-card-actions class="collapseAction">
                        <div>
                          <a href="javascript:void(0)" *ngIf="isCollapsed" class="icon x-24" (click)="showMoreLess()">
                            <img
                              src="../assets/images/icons/orange_icons/icon-collapse-arrow.png"
                              alt="icon-collapse"
                            />
                          </a>
                          <a href="javascript:void(0)" *ngIf="!isCollapsed" class="icon x-24" (click)="showMoreLess()">
                            <img
                              src="../assets/images/icons/orange_icons/icon-expand-arrow.png"
                              alt="icon-expand-arrow"
                            />
                          </a>
                        </div>
                      </mat-card-actions>
                    </div>
                  </mat-card-actions>
                </mat-card>
              </div>
            </div>
          </div>
          <div>
            <app-attachment
              (fileOutput)="receiveFileOutput($event)"
              [toggleBtn]="toggleBtn"
              [allowedTypes]="allowedTypes"
              [uploadType]="multiple"
              [editId]="editId"
              activityModuleFlag="true"
            ></app-attachment>
          </div>

          <div class="row" *ngIf="!ifCoupled">
            <div class="row nomarLR padTB16">
              <div class="col-2">
                <button
                  mat-raised-button
                  class="primary-btn btnfullWdth"
                  name="sendbutton"
                  [disabled]="f.invalid || sendDisable"
                  (click)="send()"
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </form>
      </mat-card-content>
      <mat-card-actions class="collapseAction m-auto">
        <div>
          <mat-card-actions class="collapseAction">
            <div>
              <a href="javascript:void(0)" *ngIf="isCollapsed" class="icon x-24" (click)="showMoreLess()">
                <img src="../assets/images/icons/orange_icons/icon-collapse-arrow.png" alt="icon-collapse" />
              </a>
              <a href="javascript:void(0)" *ngIf="!isCollapsed" class="icon x-24" (click)="showMoreLess()">
                <img src="../assets/images/icons/orange_icons/icon-expand-arrow.png" alt="icon-expand" />
              </a>
            </div>
          </mat-card-actions>
        </div>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
